import { Api } from '@matech/thebigpos-sdk'
import { FixMeLater } from '../types'
import { getApiHost } from '../config'

const securityWorker = (data: FixMeLater) => {
	return { headers: data }
}

const TheBigPOSClient = new Api({
	baseURL: getApiHost(window.location.host),
	securityWorker,
})

export const setBearerToken = (token: string) => {
	TheBigPOSClient.instance.defaults.headers.common.Authorization = `Bearer ${token}`
}

export const setSiteConfiguration = (siteConfigurationId: string) => {
	TheBigPOSClient.instance.defaults.headers.common[
		'Site-Configuration-ID'
	] = siteConfigurationId
}

export const TheBigPOSApi = TheBigPOSClient.api

export default TheBigPOSClient
